import findFacetByParamKey from './findFacet';
import composeFieldName from './composeFieldName';
import isFacetSearchParam from './isFacetSearchParam';
import { nonFacetSearchParams } from '../../templates/SearchForm/nonFacetSearchParams';
import { showAllQuery } from '../../../context/DataContext';

/*
 * - Deserialise URL search params to Formik values
 * - Transform Funnelback URL search param keys into easily parsed field names
 * - Transform Funnelback URL search param values into format compatible with
 *   Formik values
 */
const composeFormikValues = (searchParams, facets) => {
  const values = {
    query: '',
  };

  // add persistent keys
  /*switch(moduleType) {
    case 'event' : values['ge_endTimestamp'] = true; break;
    case 'peer-support' : values['ge_expiryTimestamp'] = true; break;
  }*/

  // Set initial values from non-facet URL search params
  const nonFacetKeys = nonFacetSearchParams.map((paramConfig) => paramConfig.paramKey);
  nonFacetKeys.forEach((key) => {
    const paramValue = searchParams.get(key);
    if (paramValue) {
      /*
       * Special case: the internal Funnelback query value
       * to show all results should display as an empty
       * string to the front-end user.
       */
      if (key === 'query' && paramValue === showAllQuery) {
        values[key] = '';
      } else {
        values[key] = paramValue;
      }
    }
  });

  searchParams.forEach((value, key) => {
    if (isFacetSearchParam(key)) {
      const matchingFacet = findFacetByParamKey(key, facets);
      if (!matchingFacet) {
        /*
         * No matching facet found:
         * Continue to next URL search param.
         */
        return;
      }
      const { customData, selectionType, selectedValues } = matchingFacet;
      const { legacyFacetQueryParameters } = customData;

      const hasMultipleValues = selectionType === 'MULTIPLE';
      if (legacyFacetQueryParameters && Object.values(legacyFacetQueryParameters).length) {
        const fieldKey = composeFieldName(Object.values(legacyFacetQueryParameters)[0].queryStringParamName);
        if (selectedValues && selectedValues.length) {
          /*
           * Store facets that allow multiple values as an array
           * and facets that only allow single values as a string.
           */
          values[fieldKey] = hasMultipleValues ? selectedValues.map((value) => value.label) : null;
        } else {
          //values[fieldKey] = hasMultipleValues ? [] : ""
        }
      }
    }
  });

  return values;
};

export default composeFormikValues;
